import React, { Fragment, useState, useEffect } from "react";
import { Card, Col, Button, Alert } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import '../../../../styles/balanco.scss'
import Moment from 'moment';

const Ouvidoria = (props) => {

    const [editar, setEditar] = useState(false);
    const [exibeBtn, setExibeBtn] = useState(false);
    const [passou, setPassou] = useState(false);
    const [id, setId] = useState("")

    Moment.locale('pt');
    Moment.updateLocale('pt', {
        months: [
            "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho",
            "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
        ]
    });

    const handleEditar = (id) => {
        setId(id);
        setEditar(true);
    }

    const dataAtualiza = Moment(props.requisicao.dataAtualiza).utc(false).format("DD [de] MMMM [de] YYYY")
    const dataPrev = Moment(props.requisicao.dataPrevisao).utc(false).format("DD [de] MMMM [de] YYYY")

    const verificaStatus = async (situacao) => {
        await verificaPassou()
        switch (situacao) {
            case 'Pendente':
            case 'Encaminhado à Secretaria Responsável':
            case 'Encaminhado à Autoridade Superior':
            case 'Encerrado':
                setExibeBtn(false);
                break;
            case 'Secretaria Responsável está atuando':
            case 'Recebido pela Prefeitura':
            case 'Resolvido':
            case 'Respondido':
            case '1º Recurso':
            case '2º Recurso':
            case 'Último Recurso':
            case 'Indeferido, justificado via mensagem':
                setExibeBtn(true);
                break;
            default:
                setExibeBtn(false);
                break;
        }
    }

    const verificaPassou = async () => {
        const datahj = Moment();
        const prev = Moment(props.requisicao.dataAtualiza).add(10, 'days');
        if (datahj > prev) {
            setPassou(true)
        }
    }

    useEffect(() => {
        verificaStatus(props.requisicao.situacao);
    }, [props.requisicao._id]);

    if (editar) {
        return (
            <Navigate to={`/ouvidoria/responder/${id}`} />
        )
    } else {
        return (
            <Fragment>
                <Col>
                    <Card className="card-list">
                        <Card.Header><h5>Sua requisição de protocolo: {props.requisicao._id}</h5></Card.Header>
                        <Card.Body>
                            <p>Situação: {props.requisicao.situacao}</p>
                            {props.requisicao.dataPrevisao ?
                                <p>Data prevista para resposta: {dataPrev}</p>
                                : null}
                            {props.requisicao.prorrogado ? <Alert variant="danger">
                                Sua requisição sofreu pedido de prorrogação de prazo de resposta!
                            </Alert> : null}
                            <h3>Histórico de mensagens:</h3>
                            {props.requisicao.respostas.length > 0 ? (
                                props.requisicao.respostas.slice().reverse().map((resposta, index) =>
                                    <Fragment key={index}>
                                        <p><strong>{resposta.quem} respondeu em {dataAtualiza}:</strong></p>
                                        <p>{resposta.conteudo}</p>
                                        {resposta.anexo ? <a href={resposta.anexo} target="_blank">Anexo</a> : ''}
                                        <br />
                                        <br />
                                        {index === 0 && resposta.quem === "Prefeitura Municipal de Macuco" && exibeBtn === true && passou === false ? (
                                            <Button variant="primary" onClick={() => handleEditar(props.requisicao._id)}>Responder</Button>
                                        ) : null}
                                        <hr />
                                    </Fragment>
                                )) : (
                                <p>Não há registro de mensagens até o momento nessa requisição!</p>)}
                        </Card.Body>
                    </Card>
                </Col>
            </Fragment >)
    }
}

export default Ouvidoria;